import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { ItemService } from 'src/app/provider/item.service';
import { AppHotelModel } from '../../models/app-hotel.model';
import { TokenFormModel } from '../../pages/auth/models/tokenform.model';

@Component({
  selector: 'kt-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit, OnDestroy, OnChanges {

  appHotel: AppHotelModel = null;

  profile: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  separatorKeysCodes = [ENTER, COMMA];

  postCodes: string[] = [];
  excludedPostCodes: string[] = [];


  constructor(
    public itemService: ItemService,
    private changeDetect: ChangeDetectorRef,
    public appHotelServ: AppHotelService
  ) {
  }

  @Input() ID: number;

  subs: Subscription[] = [];

  async ngOnInit() {
    this.appHotel = await this.appHotelServ.getAppHotel(this.profile.app_hotel_id);
  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    this.itemService.getData(this.ID, 'menu-item');

    this.itemService.record_change$.subscribe(async (resp) => {
      this.postCodes = JSON.parse(resp.delivery_post_codes);
      this.excludedPostCodes = JSON.parse(resp.excluded_post_codes);
      this.changeDetect.detectChanges();
    });
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  updatePostCode(type: string) {
    if (type === 'include') {
      this.itemService.record_change$.getValue().delivery_post_codes = JSON.stringify(this.postCodes);
    } else {
      this.itemService.record_change$.getValue().excluded_post_codes = JSON.stringify(this.excludedPostCodes);
    }

    this.onChange();
  }

  onChange() {
    const data = this.itemService.record_change$.getValue();
    this.itemService.putItem(data);
  }

}
